import {create} from 'apisauce';
// import history from '../routes/history';
// import { AuthenticationService } from '.';
// import { Messages } from '../constants';
import {EnvService} from '../services';

const WebApi = create({
  timeout: 120000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const handleResponse = (response) => {
  if (!response.ok) {
    throw response;
  }
};

const handleRequest = (request) => async () => {
  // const token = await AuthenticationService.getAuthToken();
  // if (token && !(await AuthenticationService.userIsLogged())) {
  //   history.push('/');
  //   Alert.error(Messages.LoginExpiredMessage);
  // }

  if (request.url === EnvService.get('Api_BuscaCep')) {
    const tokenCep = EnvService.get('Api_BearerTokenCep');
    request.headers.Authorization = `Bearer ${tokenCep}`;
  }
};

WebApi.addResponseTransform(handleResponse);

WebApi.addAsyncRequestTransform(handleRequest);

export default WebApi;
